export const download = (url: string, name: string): void => {
  const link = document.createElement('a')
  link.target = '_blank'
  link.download = name
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
